import { apiClient } from './client';

export interface CheckResult {
  name: string;
  status: 'ok' | 'warn' | 'error';
  latency_ms: number;
  message?: string;
  checked_at: string;
}

export interface TenantHealthResult {
  tenant_id: string;
  tenant_name: string;
  tenant_slug: string;
  overall: 'healthy' | 'degraded' | 'unhealthy';
  checks: CheckResult[];
  checked_at: string;
}

export interface PipelineHealthSummary {
  tenants: TenantHealthResult[];
  overall: 'healthy' | 'degraded' | 'unhealthy';
  checked_at: string;
}

export type PipelineHealthResponse = PipelineHealthSummary | TenantHealthResult;

export async function fetchPipelineHealth(force = false, tenantId?: string): Promise<PipelineHealthResponse> {
  const params = new URLSearchParams();
  if (force) params.set('force', 'true');
  if (tenantId) params.set('tenant_id', tenantId);
  const query = params.toString();
  const { data } = await apiClient.get<PipelineHealthResponse>(`/health/pipeline${query ? `?${query}` : ''}`);
  return data;
}
